// extracted by mini-css-extract-plugin
export default {"faqs":"Hs-z","faqContent":"Is-z","faq":"Js-z"};